import { CollectionDataCache, ItemFileData, SkinData } from "@/types";
import * as React from "react";
import CollectionSkinCard from "./collection-skin-card";

interface SkinListProps {
  data: SkinData;
  title: string;
  onItemClick: (
    itemData: ItemFileData,
    itemAddress: string,
    index?: number
  ) => void;
}

export default function ColectionSelectSkinList({
  data,
  title,
  onItemClick,
}: SkinListProps) {
  const [itemData, setItemData] = React.useState<ItemFileData | null>(null);

  React.useEffect(() => {
    const itemUrl = data.collection_data.item_data_url;
    if (itemUrl) {
      fetch(itemUrl)
        .then(res => res.json())
        .then(res => {
          setItemData(res);
        })
        .catch(console.error);
    }
  }, [data]);

  return (
    <>
      {data.items ? (
        data.items.map(nft => (
          <CollectionSkinCard
            className="text-[16px] text-[#747474]"
            key={nft.address}
            title={title}
            item={itemData}
            index={nft.index}
            onClick={() => onItemClick(itemData!, nft.address, nft.index)}
          />
        ))
      ) : (
        <CollectionSkinCard
          className="text-[16px] text-[#747474]"
          key={data.address}
          title={title}
          item={itemData}
          onClick={() => onItemClick(itemData!, data?.item?.address ?? "")}
        />
      )}
    </>
  );
}
